import {Component, HostListener, OnInit} from '@angular/core';
import {MainDestinationsComponent} from '../main/items/main-destinations/main-destinations.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DestinationsCountriesComponent} from './items/destinations-countries/destinations-countries.component';
import {HeaderService} from '../../../services/header-service';
import {Country} from '../../../model/country';
import {Location} from '@angular/common';
import {Continent} from '../../../model/circle';
import {LocationDto} from '../../../model/continent';
import {MenuService} from '../../../services/menu-services';
import {LoadingService} from '../../../services/loading-service';

@Component({
  selector: 'app-destinations-page',
  imports: [
    MainDestinationsComponent,
    DestinationsCountriesComponent,
  ],
  templateUrl: './destinations-page.component.html',
  standalone: true,
  styleUrl: './destinations-page.component.scss'
})
export class DestinationsPageComponent implements OnInit{
  constructor(private router: Router,
              protected interfaceService: HeaderService,
              public location: Location,
              private route: ActivatedRoute,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {}

  continents: Continent[] = [];
  countries: Country[] = [];
  border: boolean = false;

  filter: LocationDto = new LocationDto();

  tab: boolean = false;

  loading: boolean = false;
  loadingCircle: boolean = false;

  ngOnInit() {
    this.interfaceService.setPageInterface('header-container-white');
    this.menuService.setMobileStyle('transparent');
    if (window.innerWidth < 769) {
      this.tab = true;
    }
  }


  goToDestination(continent: Continent) {
    const url = continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url],{relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  setFilter(url: LocationDto) {
    this.filter = url;
  }

  borderEmit(event: boolean) {
    this.border = event;
  }

  loadingEmit(event: boolean) {
    this.loading = event;
    this.setLoadingService();
  }

  loadCircle(event: boolean) {
    this.loadingCircle = event;
    this.setLoadingService();
  }

  setLoadingService() {
    if (this.loadingCircle || this.loading) {
      this.loadingService.setLoadingValue(true);
    }
    if (!this.loadingCircle && !this.loading) {
      this.loadingService.setLoadingValue(false);
    }
  }

}
